// Data de hoje no horário de Brasília (UTC-3, fixo — Brasil não observa mais
// horário de verão desde 2019), independente do fuso configurado no navegador.
// NUNCA usar `new Date().toISOString().slice(0, 10)` puro: isso é UTC, e das
// 21h às 23h59 (horário de Brasília) o dia já vira o de amanhã.
export function hojeBR() {
  const d = new Date(Date.now() - 3 * 60 * 60 * 1000);
  return d.toISOString().slice(0, 10);
}

// Soma dias corridos a uma data 'YYYY-MM-DD'. Espelho de backend/src/utils/data.js.
export function somarDias(iso, dias) {
  const d = new Date(iso + 'T12:00:00');
  d.setDate(d.getDate() + dias);
  return d.toISOString().slice(0, 10);
}

// Soma meses mantendo o dia (ou o último dia do mês alvo, se não existir —
// ex.: 31/01 + 1 mês = 28/02). Espelho de backend/src/utils/data.js.
export function somarMeses(iso, meses) {
  const [y, m, dia] = iso.split('-').map(Number);
  const alvo = new Date(y, m - 1 + meses, 1, 12);
  const ultimoDia = new Date(alvo.getFullYear(), alvo.getMonth() + 1, 0).getDate();
  alvo.setDate(Math.min(dia, ultimoDia));
  return alvo.toISOString().slice(0, 10);
}

// Vencimento da parcela `indice` (0-based) a partir da 1ª — mesma regra do
// lançamento avulso de Contas a Pagar/Receber (ver
// components/financeiro/ModalNovoTituloParcelado.jsx): 'direto' (30 em 30
// dias), 'mes' (mesmo dia de cada mês), 'ndias' (a cada N dias).
export function vencimentoParcela(venc1, indice, regra, nDias) {
  if (indice === 0) return venc1;
  if (regra === 'mes')   return somarMeses(venc1, indice);
  if (regra === 'ndias') return somarDias(venc1, (parseInt(nDias) || 0) * indice);
  return somarDias(venc1, 30 * indice); // 'direto' (padrão)
}
